import {getDefaultMainMenus} from './route-model'
export const  InitialState={

    clipped: false,
    appDrawer: true,
    fixed: true,
    mainNavActive: true,
    mainMenuList:getDefaultMainMenus(),
    activeRouteItem: {
      title: '',
      route: '',
      img: '',
      children: [{}]
    },
    activeSubRouteItem: {
      title: '',
      route: '',
      img: '',
    },
    isResetPassword:null,
    appNavItems: [
      {
        title: 'royalty_account',
        route: 'royalties',
        img: 'static/icons/b2b/accounting-active.svg',
        hasPermission:true,
        children: []
      },
     
      {
        title: 'Labels',
        route: 'labels',
        img: 'static/icons/b2b/label-inactive.svg',
        hasPermission:true,
        children: [
          { icon: 'Boxer Recordings', title: 'Boxer Recordings', route: 'boxer_recordings', img:'static/icons/b2b/label-inactive.svg' ,parent:'Labels' },
          { icon: 'Boxer Digital', title: 'Boxer Digital', route: 'boxer_digital', img:'static/icons/b2b/label-inactive.svg',parent:'Labels' },
          { icon: 'Kick Boxer', title: 'Kick Boxer', route: 'kick_koxer' , img:'static/icons/b2b/label-inactive.svg' ,parent:'Labels'},]
      },
      {
        title: 'Releases',
        route: 'releases',
        img: 'static/icons/b2b/booking-grey.svg',
        hasPermission:true,
        children: [
          { icon: 'Total 2020', title: 'Total 2020', route: 'total_2020', img:'static/icons/b2b/booking-grey.svg',parent:'Releases' },
        ]
  
      }
      
     
    ],
    
    royalties: [
  
    ],
    royaltyReports:{
      top_digital_shops: [],
      top_countries:[],
      top_releases:[]
    },
    selectedRoyaltyItem:{},
    royalty_period_id:'',
  
    loginUser: {
      email: '',
      password: ''
    },
    resetPassword: {
      username: '',
    },
    user: {given_name:''},
    is_Logged_In:false,
    is_Loaded_Data:false,
    loading_Text:'No Data Available',
    loginRedirectRoute: {
      name: 'b2b',
      params: {},
      query: {}
    },
    redirectRoute:'/b2b/royalties',
    userDetails:{

    


}
}